export default __webpack_public_path__ + "static/media/myflix-react.4d3732a7.png";